import { Layout } from 'antd';
import deviceStore from '../../stores/Classes/DeviceStore';
import styled from 'styled-components';

interface LayoutProps {
  readonly collapsed: boolean;
  readonly device: string;
}

const StyledLayout = styled(Layout)<LayoutProps>`
  min-height: 100vh;
  transition: all 0.3s ease;
  margin-left: ${(props) =>
    props.collapsed
      ? '0px'
      : props.device === 'mobile' || props.device === 'tablet'
        ? '0px'
        : '250px'};
  padding: 24px 0px 24px 24px;

  @media (max-width: 992px) {
    padding: 24px 0px;
  }

  @media (max-width: 576px) {
    padding: 0px;
  }
`;

export default StyledLayout;
